import { System } from '../../shared-components/System';

export enum StudentHealthInfoTabsIndex {
    HealthConditions,
    Restrictions,
    Practitioners,
    Insurance,
    Pregnancy
}

export enum StudentHealthChartTabsIndex {
    HealthVisits,
    Immunizations,
    Medications,
    Screenings
}

export class HealthCondition {
    Id: number;
    GradeLevelId: number;
    DateConditionStart: Date;
    DateConditionEnd: Date;
    HealthConditionCodeId: number;
    DateHomeTeachingStart: Date;
    DateHomeTeachingEnd: Date;
    GenerateAlert: boolean;
    NonNurseViewable: boolean;
    Referral: boolean;
    ReferralReturnedToSchool: boolean;
    DateReferralReturn: Date;
    UnderDoctorsCare: boolean;
    Comment: string;
    GradeLevelCode: string;
    GradeLevelDescription: string;
    HealthConditionCode: string;
    HealthConditionDescription: string;
    HealthConditionCodeDesc: string;
    SiteCode: string;
    YearCode: string;
    Notes: string;
    Attachment: boolean;
    ShowAccessingStudentHealth: boolean;
    AcuteCondition: boolean;
    ChronicCondition: boolean;
    HealthConditionAttachments: HealthConditionAttachment[] = [];

    // non DTO fields
    NonNurseViewableValue: string;
    GenerateAlertValue: string;
}

export class HealthConditionAttachment {
    DocumentId: number;
    HealthConditionId: number;
    Description: string;
    FileName: string;
    FileMimeType: string;
    AttachmentAddedOn: string;
    AttachmentAddedBy: string;
    Deleted: boolean;
    DocumentBase64: string;

    // Non DTO Filed
    MyFileBase64String: string;
    FileType: string;
}

export class HealthConditionCode {
    Id: number;
    SequenceNo: number;
    Code: string;
    Description: string;
    ShowAlert: boolean;
    ViewableByNonNurse: boolean;
    ShowAccessingStudentHealth: boolean;
    InActive: boolean;
}

export class Pregnancy {
    Id: number;
    StudentId: number;
    SiteId: number;
    YearId: number;
    DateOfTest: Date;
    DateExpecting: Date;
    DateOfDeliveryOrTermination: Date;
    DateHomeTeachingStart: Date;
    DateHomeTeachingEnd: Date;
    ClinicName: string;
    HospitalName: string;
    GradeLevelCode: string;
    DeliveryResultCode: string;
    DeliveryResultId: number;
    Comment: string;
    GradeLevelDescription: string;
    SiteCode: string;
    YearCode: string;
    Attachment: boolean;
    PregnancyAttachments: PregnancyAttachment[] = [];

    // Non DTO Filed
    tempDeliveryResultId: string;
}


export class PregnancyAttachment {
    DocumentId: number;
    PregnancyId: number;
    Description: string;
    FileName: string;
    FileMimeType: string;
    AttachmentAddedOn: string;
    AttachmentAddedBy: string;
    Deleted: boolean;
    DocumentBase64: string;

    // Non DTO Filed
    MyFileBase64String: string;
    FileType: string;
}

export class HealthRestriction {
    Id: number;
    GradeLevelId: number;
    DateRestrictionStart: Date;
    DateRestrictionEnd: Date;
    Period: string;
    GenerateAlert: boolean;
    NonNurseViewableAlert: boolean;
    ShowOnStudentHealth: boolean;
    Practioner: string;
    PractionerId: number;
    UnderDoctorsCare: boolean;
    Referral: boolean;
    ReferralReturnedToSchool: boolean;
    DateReferralReturn: Date;
    Comment: string;
    GradeLevelCode: string;
    GradeLevelDescription: string;
    SiteCode: string;
    YearCode: string;
    Notes: string;
    Attachment: boolean;
    HealthRestrictionAttachments: RestrictionAttachment[] = [];

    // Non DTO Filed
    tempPractionerId: string;
    NonNurseViewableValue: string;
    GenerateAlertValue: string;
}

export class RestrictionAttachment {
    DocumentId: number;
    RestrictionId: number;
    Description: string;
    FileName: string;
    FileMimeType: string;
    AttachmentAddedOn: string;
    AttachmentAddedBy: string;
    Deleted: boolean;
    DocumentBase64: string;

    // Non DTO Filed
    MyFileBase64String: string;
    FileType: string;
}

export class PractitionersAndInsurances {
    Id: number;
    PractitionerType: string;
    PhysicianName: string;
    PractitionerNameOrPolicy: string;
    Policy: string;
    Primary: string;
    Phone: string;
    DateStart: Date;
    DateEnd: Date;
    Comment: string;
    Address: string;
    Email: string;
    ExchangePhone: string;
    PractitionerTypeId: number;
    PhysiciansCode: string;
    Attachment: boolean;
    PhysiciansAttachments: PhysiciansAttachment[] = [];

    // Non DTO Filed
    tempPractitionerTypeId: string;
}

export class PhysiciansAttachment {
    DocumentId: number;
    PhysiciansId: number;
    Description: string;
    FileName: string;
    FileMimeType: string;
    AttachmentAddedOn: string;
    AttachmentAddedBy: string;
    Deleted: boolean;
    DocumentBase64: string;

    // Non DTO Filed
    MyFileBase64String: string;
    FileType: string;
}

export class HealthVisit {
    Id: number;
    DateOfVisit: Date;
    TimeIn: string;
    TimeOut: string;
    Reason: string;
    ReasonDescription: string;
    Action: string;
    SentTo: string;
    TreatedBy: string;
    Medication: string;
    SiteCode: string;
    Deleted: boolean;
    YearId: number;
    MedicationId: string;
    DOHSurveillanceId: number;
    CallMadeTo: string;
    InjuryMajor: boolean;
    InjuryMinor: boolean;
    Referral: boolean;
    Report: boolean;
    Illness: boolean;
    EMSCall: boolean;
    Treated: boolean;
    NoticeSent: boolean;
    AEDUsed: boolean;
    ReferralReturnedToSchool: boolean;
    Temperature: number;
    ICD9: string;
    EvaluationOfClinicVisit: string;
    Comments: string;
    Glucose: string;
    Units: string;
    Carb: string;
    BloodPressure: string;
    OnDutyUserId: number;
    SelectedCodeTreatmentIds: string;
    DateReferralReturned: Date;
    ClinicVisitLogCodeId: number;
    LastUpdatedByUserName: string;
    LastUpdatedDate: Date;
    NatureOfInjuryId: number;
    TimePeriodOfInjuryId: number;
    LocationOfInjuryId: number;
    Pulse: string;
    Respiration: string;
    SpO2: string;
    SentId: number;
    PeriodsExcused: string;
    ClinicVisitNoShowId: number;
    ClinicTreatmentIds: number[] = [];
    ClinicLogMedications: HealthVisitMedications[];
    // Non DTO Field //
    TreatmentIds: string[] = [];
    filterActionTakens: string;
    filteredMedications: string;
    IsTodaysLog: boolean;
    AllowEdit: boolean;
}

export class StudentHealthNotes {
    StudentId: number;
    MedicalConditionNote: string;
    RestrictionNote: string;
    PractitionerNote: string;
    InsuranceNote: string;
    PregnancyNote: string;
    HealthVisitNote: string;
    ImmunizationNote: string;
    MedicationNote: string;
    ScreeningNote: string;
    RecordStatus: string;
    Note: string;
}

export class HealthVisitMedications {
    Id: number;
    ClinicLogMedicationId: number;
    MedicationCodeId: number;
    RouteId: number;
    Selected: boolean;
    Code: string;
    Description: string;
    Dose: string;
    Route: string;
    Frequency: string;
    DispenceTime: string;
    Comments: string;
    ScheduledFrequencyId: number;
    ScheduledDispenseTime: string;
    ScheduledDose: string;
    ScheduledRouteId: number;
    ParentPermissionToDispense: boolean;
    DocPermissionToDispense: boolean;
    ScheduledDoseOrder: string;
    ScheduledFrequency: string;
    ScheduledRoute: string;
    MedicationStartDate: Date;
    MedicationEndDate: Date;
    Administered: string;
    // Non DTO Field //
    Deleted: boolean;
}

export class HearingScreening {
    Id: number;
    YearId: number;
    ScreeningName: string;
    ScreeningSeries: string;
    ScreenedOn = new Date(System.junkDateString);
    Results: string;
    Referred: boolean;
    ReferredStatus: string;
    Comments: string;
    StudentId: number;
    ScreeningNameId: number;
    ScreeningSeriesId: number;
    ScreeningReasonId: number;
    ScreeningResultsId: number;
    ScreenedById: number;
    LastUpdatedByUserName: string;
    Right2501Hz: string;
    Right5001Hz: string;
    Right10001Hz: string;
    Right20001Hz: string;
    Right40001Hz: string;
    Right80001Hz: string;
    Left2501Hz: string;
    Left5001Hz: string;
    Left10001Hz: string;
    Left20001Hz: string;
    Left40001Hz: string;
    Left80001Hz: string;
    HasAssistHearingDevice: boolean;
    UnderDoctorsCare: boolean;
    UsedAtScreening: boolean;
    FollowUpDate = new Date(System.junkDateString);
    ParentContact: string;
    ParentContactId: number;
    ScreeningResults: string;
    ScreeningReason: string;
    RightEarTestCode: string;
    RightEarTestDescription: string;
    LeftEarTestCode: string;
    LeftEarTestDescription: string;
    ReferredDate = new Date(System.junkDateString);
    AudiologistReferralId: number;
    TreatmentReportSent: boolean;
    TreatmentReportReceived: string;
    DateInitiated = new Date(System.junkDateString);
    DateOfExam = new Date(System.junkDateString);
    DateReportReceived = new Date(System.junkDateString);
    ReferredStatusId: number;
    DiagnosisId: number;
    TreatmentId: number;
    AudiologistRecommendations: string;
    DiagnosisDate = new Date(System.junkDateString);
    ReferralReturned: boolean;
    ReferralReturnDate = new Date(System.junkDateString);
    RightEardB: number;
    RightEarHz: number;
    LeftEardB: number;
    LeftEarHz: number;
    AudiogramDate1 = new Date(System.junkDateString);
    NextAudiogramDue = new Date(System.junkDateString);
    WatchList: boolean;
    SignerUsed: boolean;
    PureToneAvgRight1: string;
    PureToneAvgLeft1: string;
    MeetsCriteriaReferralId: number;
    MonitorAudiogram1Id: number;
    ScheduleOn = new Date(System.junkDateString);
    ScreenedBy: string;
    EnteredBy: string;
    EnteredById: number;
    LastUpdatedOn = new Date(System.junkDateString);
    StudentFirstName: string;
    StudentLastName: string;
    StudentMiddleName: string;
    StudentNumber: string;
    Gender: string;
    Grade: string;
    SchoolName: string;
    SchoolCode: string;
    ClassroomScreeningTool: boolean;
    MedicalReferralNotCompleted: boolean;
    CommunicationAccommodations: boolean;

    AudiogramDate2 = new Date(System.junkDateString);
    MonitorAudiogram2Id: number;
    Right2502Hz: string;
    Right5002Hz: string;
    Right10002Hz: string;
    Right20002Hz: string;
    Right40002Hz: string;
    Right80002Hz: string;
    Left2502Hz: string;
    Left5002Hz: string;
    Left10002Hz: string;
    Left20002Hz: string;
    Left40002Hz: string;
    Left80002Hz: string;
    PureToneAvgRight2: string;
    PureToneAvgLeft2: string;
    HearingAidWorn: boolean;
    ScreeningRightId: number;
    ScreeningLeftId: number;
    ReScreeningRightId: number;
    ReScreeningLeftId: number;

    ScreeningDiagnosis: string;
    ScreeningTreatment: string;
    StudentName: string;

    MonitorAudiogram1: string;
    MonitorAudiogram2: string;
    ScreeningRight: string;
    ScreeningLeft: string;
    ReScreeningRight: string;
    ReScreeningLeft: string;
    MeetsCriteriaForReferral: string;
    AudiologistReferrelIndicated: string;
    ReferralDiagnosisId: number;
    ReferralTreatmentId: number;
    ReferralDiagnosis: string;
    ReferralTreatment: string;
    SensitivityResultRight1Id: number;
    SensitivityResultLeft1Id: number;
    SensitivityResultRight2Id: number;
    SensitivityResultLeft2Id: number;
    EnteredOn = new Date(System.junkDateString);
    RightEardB2: number;
    RightEarHz2: number;
    LeftEardB2: number;
    LeftEarHz2: number;
    // Non DTO

    get kendoSelectBy() {
        return this.Id;
    }
}
export class ScreeningNames {
    ID: number;
    Code: string;
    Description: string;
    ScreeningTypeID: number;
    Inactive: boolean;
}
export class ScreeningSeries {
    ID: number;
    Code: string;
    Description: string;
    ScreeningTypeID: number;
    ScreeningNameID: number;
    Inactive: boolean;
}

export class ExistScreeningsRecord {
    ScreeningId: number;
    StudentId: number;
    StudentName: string;
}

export class SpinalScreening {
    Id: number;
    YearId: number;
    ScreeningName: string;
    ScreeningSeries: string;
    ScreenedOn = new Date(System.junkDateString);
    Results: string;
    ScreeningResultsId: number;
    ScreenedBy: string;
    ScreenedById: number;
    EnteredBy: string;
    EnteredById: number;
    EnteredOn = new Date(System.junkDateString);
    ContinueObservation: string;
    ContinueObservationId: number;
    ParentContact: string;
    ParentContactId: number;
    UnderDoctorsCare: boolean;
    FollowUpDate = new Date(System.junkDateString);
    Comments: string;
    Referred: boolean;
    ReferredDate = new Date(System.junkDateString);
    ReferredStatus: string;
    ReferredStatusId: number;
    ReferralReturnDate = new Date(System.junkDateString);
    ReferralReturned: boolean;
    ScreeningNameId: number;
    ScreeningSeriesId: number;
    ReferralDiagnosis: string;
    ReferralDiagnosisId: number;
    ReferralTreatment: string;
    ReferralTreatmentId: number;
    DiagnosisTreatmentDate = new Date(System.junkDateString);
    LastUpdatedByUserName: string;
    LastUpdatedOn = new Date(System.junkDateString);
    StudentFirstName: string;
    StudentLastName: string;
    StudentMiddleName: string;
    StudentNumber: string;
    Gender: string;
    Grade: string;
    SchoolName: string;
    SchoolCode: string;
    StudentName: string;
    StudentId: number;
    // Non DTO
    get kendoSelectBy() {
        return this.Id;
    }
}

export class PhysicalScreening {
    Id: number;
    YearId: number;
    ScreeningName: string;
    ScreeningSeries: string;
    ScreenedOn = new Date(System.junkDateString);
    Results: string;
    ScreeningNameId: number;
    ScreeningSeriesId: number;
    ScreeningResultsId: number;
    ScreenedBy: string;
    ScreenedById: number;
    EnteredBy: string;
    EnteredById: number;
    ExaminedBy: string;
    ExaminedById: number;
    SportsScreening: string;
    SportsScreeningId: number;
    Comments: string;
    Referred: boolean;
    ReferredDate = new Date(System.junkDateString);
    ReferredStatus: string;
    ReferredStatusId: number;
    ReferralReturnDate = new Date(System.junkDateString);
    ReferralReturned: boolean;
    ReferralDiagnosis: string;
    ReferralDiagnosisId: number;
    ReferralTreatment: string;
    ReferralTreatmentId: number;
    DiagnosisTreatmentDate = new Date(System.junkDateString);
    HeightinFeet: number;
    HeightinInches: number;
    HeightPercentile: number;
    Weight: number;
    WeightPercentile: number;
    BloodPresure: string;
    LeadBloodTest: string;
    BodyMaxIndex: number;
    BodyMaxIndexPercentile: number;
    DiabAtRisk: boolean;
    DiabEthnicMin: boolean;
    DiabFamilyHist: boolean;
    DiabInsulinRes: boolean;
    ExamComplete: boolean;
    DoctorDidExam: boolean;
    ClinicDidExam: boolean;
    LastUpdatedByUserName: string;
    LastUpdatedOn = new Date(System.junkDateString);
    StudentFirstName: string;
    StudentLastName: string;
    StudentMiddleName: string;
    StudentNumber: string;
    Gender: string;
    Grade: string;
    SchoolName: string;
    SchoolCode: string;
    StudentName: string;
    StudentId: number;
    EnteredOn = new Date(System.junkDateString);

    get kendoSelectBy() {
        return this.Id;
    }
}

export class StateRequiredHearingFields {
    Str250Hz: boolean;
    Str500Hz: boolean;
    Str1000Hz: boolean;
    Str2000Hz: boolean;
    Str4000Hz: boolean;
    Str8000Hz: boolean;
    StrDB: boolean;
    StrHz: boolean;
}

export class DentalScreening {
    Id: number;
    YearId: number;
    ScreeningName: string;
    ScreeningSeries: string;
    ScreenedOn = new Date(System.junkDateString);
    Results: string;
    ScreeningResultsId: number;
    ScreenedBy: string;
    ScreenedById: number;
    EnteredBy: string;
    EnteredById: number;
    EnteredOn = new Date(System.junkDateString);
    UnderDoctorsCare: boolean;
    Comments: string;
    Referred: boolean;
    ReferredDate = new Date(System.junkDateString);
    ReferredStatus: string;
    ReferredStatusId: number;
    ReferralReturnDate = new Date(System.junkDateString);
    ReferralReturned: boolean;
    ScreeningNameId: number;
    ScreeningSeriesId: number;
    ReferralDiagnosis: string;
    ReferralDiagnosisId: number;
    ReferralTreatment: string;
    ReferralTreatmentId: number;
    DiagnosisTreatmentDate = new Date(System.junkDateString);
    LastUpdatedByUserName: string;
    LastUpdatedOn = new Date(System.junkDateString);
    StudentFirstName: string;
    StudentLastName: string;
    StudentMiddleName: string;
    StudentNumber: string;
    Gender: string;
    Grade: string;
    SchoolName: string;
    SchoolCode: string;
    StudentName: string;
    StudentId: number;
    ExaminedById: number;
    ExaminedBy: string;
    WaiverCode: string;
    Waiver: string;
    ExemptCode: string;
    Exempt: string;
    FluorideProgramId: number;
    FluorideProgram: string;
    CariesExperience: boolean;
    CariesUntreated: boolean;
    Malocclusion: boolean;
    SoftTissuePathology: boolean;
    Sealant: boolean;
    NoConcerns: boolean;
    Cavity: boolean;
    Gums: boolean;
    MissingTooth: boolean;
    OtherConcern: boolean;
    Cleaning: boolean;
    Fluoride: boolean;
    PreventiveCare: boolean;
    RestorativeCare: boolean;
    UrgentTreatment: boolean;
    // Non DTO
    get kendoSelectBy() {
        return this.Id;
    }
}

export class VisionScreening {
    Id: number;
    YearId: number;
    ScreeningName: string;
    ScreeningSeries: string;
    ScreenedOn = new Date(System.junkDateString);
    Results: string;
    ScreeningResultsId: number;
    ScreenedBy: string;
    ScreenedById: number;
    EnteredBy: string;
    EnteredById: number;
    EnteredOn = new Date(System.junkDateString);
    UnderDoctorsCare: boolean;
    Comments: string;
    WearsContacts: boolean;
    WearsGlasses: boolean;
    GlassesDuringScreening: string;
    GlassesDuringScreeningId: number;
    ComprehensiveEyeExam: string;
    VisionTest: string;
    VisionTestId: number;
    AutoScreeningDeviceUsed: boolean;
    LPhoria: string;
    LPhoriaId: number;
    VPhoria: string;
    VPhoriaId: number;
    Hyperopia: string;
    HyperopiaId: number;
    Myopia: string;
    MyopiaId: number;
    Strabismus: string;
    StrabismusId: number;
    InternalEyeHealth: string;
    InternalEyeHealthId: number;
    ExternalEyeHealth: string;
    ExternalEyeHealthId: number;
    MuscularBalanceFar: string;
    MuscularBalanceFarId: number;
    MuscularBalanceNear: string;
    MuscularBalanceNearId: number;
    BinocularFar: string;
    BinocularFarId: number;
    BinocularNear: string;
    BinocularNearId: number;
    AcuityFarBinocular: string;
    AcuityFarRight: string;
    AcuityFarLeft: string;
    AcuityFarBestCorrectedRight: string;
    AcuityFarBestCorrectedLeft: string;
    AcuityNearBinocular: string;
    AcuityNearRight: string;
    AcuityNearLeft: string;
    AcuityNearBestCorrectedRight: string;
    AcuityNearBestCorrectedLeft: string;
    AcuityBinocularCorrected: string;
    VisualAcuity: string;
    VisualAcuityId: number;
    RefractionLeft: string;
    ConvexLens: string;
    ConvexLensId: number;
    DepthPerception: string;
    DepthPerceptionId: number;
    MedicalDiagnosis: string;
    MedicalDiagnosisId: number;
    CorrectiveLensesPrescribed: string;
    CorrectiveLensesPrescribedId: number;
    Examiner: string;
    OutsideProvider: string;
    Equipment: string;
    Payer: string;
    PayerId: number;
    ParentContactMethod: string;
    FollowupDate: Date;
    Referred: boolean;
    ReferredDate = new Date(System.junkDateString);
    ReferredStatus: string;
    ReferredStatusId: number;
    ReferralReturnDate = new Date(System.junkDateString);
    ReferralReturned: boolean;
    ScreeningNameId: number;
    ScreeningSeriesId: number;
    ReferralDiagnosis: string;
    ReferralDiagnosisId: number;
    ReferralTreatment: string;
    ReferralTreatmentId: number;
    DiagnosisTreatmentDate = new Date(System.junkDateString);
    ReferralIndicated: string;
    GlassesReferral: string;
    ReferralNotReturned: boolean;
    LastUpdatedByUserName: string;
    LastUpdatedOn = new Date(System.junkDateString);
    StudentFirstName: string;
    StudentLastName: string;
    StudentMiddleName: string;
    StudentNumber: string;
    Gender: string;
    Grade: string;
    SchoolName: string;
    SchoolCode: string;
    StudentName: string;
    StudentId: number;
    ColorVision: string;
    ColorVisionId: number;
    WNL: string;
    ONL: string;
    Amblyopia: string;
    AmblyopiaId: number;
    RefractionRight: string;

    // IL Specific
    PreschoolRightEye: string;
    PreschoolRightEyeId: number;
    PreschoolLeftEye: string;
    PreschoolLeftEyeId: number;
    PreschoolUnabletoTest: string;
    ElementaryVisualAcuityRight: string;
    ElementaryVisualAcuityRightId: number;
    ElementaryVisualAcuityLeft: string;
    ElementaryVisualAcuityLeftId: number;
    ElementaryColorVision: string;
    ElementaryPlusLensRight: string;
    ElementaryPlusLensRightId: number;
    ElementaryPlusLensLeft: string;
    ElementaryPlusLensLeftId: number;
    ElementaryUnabletoTest: string;
    ElementaryGlassesRepairNeeded: string;
    SecondaryAcuityFarRight: string;
    SecondaryAcuityFarRightId: number;
    SecondaryAcuityFarLeft: string;
    SecondaryAcuityFarLeftId: number;
    SecondaryAcuityFarBoth: string;
    SecondaryAcuityFarBothId: number;
    SecondaryAcuityNearRight: string;
    SecondaryAcuityNearRightId: number;
    SecondaryAcuityNearLeft: string;
    SecondaryAcuityNearLeftId: number;
    SecondaryAcuityNearBoth: string;
    SecondaryAcuityNearBothId: number;
    SecondaryUnabletoTest: string;
    RescreeningDate: Date;
    RescreenedPreschoolRightEye: string;
    RescreenedPreschoolRightEyeId: number;
    RescreenedPreschoolLeftEye: string;
    RescreenedPreschoolLeftEyeId: number;
    RescreenedElementaryMuscleBalanceNear: string;
    RescreenedElementaryMuscleBalanceNearId: number;
    RescreenedElementaryMuscleBalanceFar: string;
    RescreenedElementaryMuscleBalanceFarId: number;
    RescreenedElementaryVisualAcuityRight: string;
    RescreenedElementaryVisualAcuityRightId: number;
    RescreenedElementaryVisualAcuityLeft: string;
    RescreenedElementaryVisualAcuityLeftId: number;
    RescreenedElementaryColorVision: string;
    RescreenedElementaryPlusLensLeft: string;
    RescreenedElementaryPlusLensLeftId: number;
    RescreenedElementaryPlusLensRight: string;
    RescreenedElementaryPlusLensRightId: number;
    RescreenedElementaryUnabletoTest: string;
    RescreenedElementaryGlassesRepairNeeded: string;
    RescreenedSecondaryAcuityFarRight: string;
    RescreenedSecondaryAcuityFarRightId: number;
    RescreenedSecondaryAcuityFarLeft: string;
    RescreenedSecondaryAcuityFarLeftId: number;
    RescreenedSecondaryAcuityFarBoth: string;
    RescreenedSecondaryAcuityFarBothId: number;
    RescreenedSecondaryAcuityNearRight: string;
    RescreenedSecondaryAcuityNearRightId: number;
    RescreenedSecondaryAcuityNearLeft: string;
    RescreenedSecondaryAcuityNearLeftId: number;
    RescreenedSecondaryAcuityNearBoth: string;
    RescreenedSecondaryAcuityNearBothId: number;
    RescreeningResults: string;
    RescreeningResultsId: number;
    LastEyeExamDate: Date;
    VisionExamDate: Date;
    StudentStatus: string;
    Pathology: string;
    MuscleBalanceIssue: string;
    AmblyopiaIL: string;
    ContactsPrescribed: string;
    GlassesPrescribed: string;
    UnderDoctorsCareIL: string;
    PreferentialSeating: string;
    ReExamDate: Date;
    ExternalEyeHealthIL: string;
    InternalEyeHealthIL: string;
    PupillaryReflex: string;
    BinocularFunction: string;
    AccommodationVergence: string;
    GlaucomaEvaluation: string;
    OculomotorAssessment: string;
    // Non DTO
    get kendoSelectBy() {
        return this.Id;
    }

}

export class ImmunizationExemptions {
    Vaccine: string;
    Exemption: string;
    ExemptionDate: string;
}

export class Vaccine {
    Id: number;
    Exempt: string;
    ExemptId: number;
    VaccineId: number;
    Vaccine: string;
    Date1: Date;
    Date2: Date;
    Date3: Date;
    Date4: Date;
    Date5: Date;
    Date6: Date;
    Date7: Date;
    Date8: Date;
    Date9: Date;
    Date10: Date;
    ExemptDate: Date;

    constructor(initDates?: boolean) {
        if (initDates == true) {
            this.Date1 = new Date(System.junkDateString);
            this.Date2 = new Date(System.junkDateString);
            this.Date3 = new Date(System.junkDateString);
            this.Date4 = new Date(System.junkDateString);
            this.Date5 = new Date(System.junkDateString);
            this.Date6 = new Date(System.junkDateString);
            this.Date7 = new Date(System.junkDateString);
            this.Date8 = new Date(System.junkDateString);
            this.Date9 = new Date(System.junkDateString);
            this.Date10 = new Date(System.junkDateString);
        }

    }
}

export class HealthVisitSearchParam {
    FromDate: Date;
    ToDate: Date;
    IsStaff: boolean;
    IsStudent: boolean;
    ShowDeleted: boolean;
}